import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"

import styles from "./progressBar.css"

const ProgressBar = ({ percent = 0, rootStyle, contentStyle, playInProgress }) => (
  <div className={classNames(styles.root, rootStyle)}>
    <div className={styles.background} />
    <div
      className={classNames(styles.content, contentStyle, { [styles.contentPlayInProgress]: playInProgress })}
      style={{ width: `${percent <= 100 ? percent : 100}%` }}
    />
  </div>
)

ProgressBar.propTypes = {
  percent: PropTypes.number,
  rootStyle: PropTypes.string,
  contentStyle: PropTypes.string,
  playInProgress: PropTypes.bool,
}

export default ProgressBar
